
    import '/opt/buildhome/repo/components/x-provider/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["x-provider-demo-use"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/opt/buildhome/repo/components/x-provider/index.zh-CN.md?type=demo')
};